if (!customElements.get('tabbed-collections')) {
  class TabbedCollections extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.tabbed-collections__tab');
      this.panels = this.querySelectorAll('.tabbed-collections__content');
      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });

      this.querySelectorAll('.tabbed-collections__scroll-button').forEach(button => {
        button.addEventListener('click', () => this.scroll(button));
      });
      
      // Initial scroll button state
      this.panels.forEach(panel => {
        const carousel = panel.querySelector('[data-carousel]');
        if (carousel) {
          this.updateScrollButtons(panel, carousel);
          carousel.addEventListener('scroll', () => this.updateScrollButtons(panel, carousel), { passive: true });
        }
      });
    }

    switchTab(selectedTab) {
      const index = selectedTab.dataset.tabIndex;
      
      this.tabs.forEach(tab => {
        const isActive = tab === selectedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach(panel => {
        const isActive = panel.dataset.panelIndex === index;
        panel.classList.toggle('is-active', isActive);
      });
    }

    scroll(button) {
      const panel = button.closest('.tabbed-collections__content');
      const carousel = panel.querySelector('[data-carousel]');
      const direction = button.dataset.control === 'next' ? 1 : -1;
      const scrollAmount = carousel.offsetWidth * 0.8 * direction;
      
      carousel.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }

    updateScrollButtons(panel, carousel) {
      const prevButton = panel.querySelector('[data-control="prev"]');
      const nextButton = panel.querySelector('[data-control="next"]');

      if (prevButton) {
        prevButton.disabled = carousel.scrollLeft <= 5;
      }
      
      if (nextButton) {
        nextButton.disabled = (carousel.scrollLeft + carousel.offsetWidth) >= (carousel.scrollWidth - 5);
      }
    }
  }

  customElements.define('tabbed-collections', TabbedCollections);
}
